////////LIBRARY/////////
import update from 'immutability-helper'
import { map, cloneDeep } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const companiesManager = {
	[ActionsTypes.GET_COMPANIES]: (state) =>
		update(state, {
			companiesManager: {
				isLoading: {
					$set: true,
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_COMPANIES_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}
		return update(state, {
			companiesManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.GET_COMPANIES_FAILURE]: (state, payload) =>
		update(state, {
			companiesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SET_USER_COMPANY_ID]: (state, payload) => {
		let companyId = payload.companyId
		return update(state, {
			usersManager: {
				companyId: {
					$set: companyId,
				},
			},
		})
	},
	[ActionsTypes.SET_STATE_COMPANY]: (state, _payload) =>
		update(state, {
			companiesManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.SET_STATE_COMPANY_FAILURE]: (state, payload) => {
		return update(state, {
			companiesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.SET_STATE_COMPANY_SUCCESS]: (state, payload) => {
		let current_companies = cloneDeep(state.companiesManager.items)

		map(current_companies, (elem, id) => {
			if (elem.id === payload.idCompany) {
				current_companies[id] = payload.data
			}
		})

		return update(state, {
			companiesManager: {
				isLoading: {
					$set: false,
				},
				update: {
					$set: true,
				},
				items: {
					$set: current_companies,
				},
			},
		})
	},

	[ActionsTypes.GET_COMPANY_AVAILABLE_LISTS]: (state) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.GET_COMPANY_AVAILABLE_LISTS_SUCCESS]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				availableOptions: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_COMPANY_AVAILABLE_LISTS_FAILURE]: (state, payload) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.CREATE_COMPANY]: (state) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.CREATE_COMPANY_SUCCESS]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
			},
			initKioskCreation: {
				definition: {
					idCompanyCreated: {
						$set: payload.data.id,
					},
					rsCompanyCreated: {
						$set: payload.data.labelCommercial,
					},
				},
			},
		})
	},
	[ActionsTypes.CREATE_COMPANY_FAILURE]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_COMPANY_DATA]: (state) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.GET_COMPANY_DATA_SUCCESS]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				availableOptions: {
					$set: payload.data,
				},
				item: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_COMPANY_DATA_FAILURE]: (state, payload) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.UPDATE_COMPANY]: (state) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_COMPANY_SUCCESS]: (state, _payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_COMPANY_FAILURE]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.RESET_DATA_COMPANY]: (state) => {
		return update(state, {
			companyDetail: {
				item: {
					$set: false,
				},
				availableOptions: {
					$set: false,
				},
				update: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.CHECK_DISTRIBUTION_GROUP_DISABLING]: (state) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: true,
				},
				distributionGroupChecked: {
					$set: {},
				},
			},
		}),
	[ActionsTypes.CHECK_DISTRIBUTION_GROUP_DISABLING_SUCCESS]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				distributionGroupChecked: {
					$set: {
						id: payload.id,
						canDisabled: payload.value,
					},
				},
			},
		})
	},
	[ActionsTypes.CHECK_DISTRIBUTION_GROUP_DISABLING_FAILURE]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				distributionGroupChecked: {
					$set: {
						id: payload.id,
						canDisabled: payload.value,
					},
				},
			},
		})
	},
	[ActionsTypes.CHECK_DISTRIBUTION_DISABLING]: (state) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: true,
				},
				distributionChecked: {
					$set: {},
				},
			},
		}),
	[ActionsTypes.CHECK_DISTRIBUTION_DISABLING_SUCCESS]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				distributionChecked: {
					$set: {
						id: payload.id,
						canDisabled: payload.value,
					},
				},
			},
		})
	},
	[ActionsTypes.CHECK_DISTRIBUTION_DISABLING_FAILURE]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				distributionChecked: {
					$set: {
						id: payload.id,
						canDisabled: payload.value,
					},
				},
			},
		})
	},
	[ActionsTypes.DELETE_TECH_SUPPORT]: (state) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: true,
				},
				maintainerChecked: {
					$set: {},
				},
			},
		}),
	[ActionsTypes.DELETE_TECH_SUPPORT_SUCCESS]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				maintainerChecked: {
					$set: {
						id: payload.id,
						canDisabled: payload.value,
					},
				},
			},
		})
	},
	[ActionsTypes.DELETE_TECH_SUPPORT_FAILURE]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				maintainerChecked: {
					$set: {
						id: payload.id,
						canDisabled: payload.value,
					},
				},
			},
		})
	},
	[ActionsTypes.PUT_SMS_REFILL]: (state) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.PUT_SMS_REFILL_SUCCESS]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.PUT_SMS_REFILL_FAILURE]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP]: (state) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP_SUCCESS]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP_FAILURE]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_LINK]: (state) =>
		update(state, {
			companyDetail: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_LINK_SUCCESS]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.PUT_DELETE_COMPANY_SUBGROUP_LINK_FAILURE]: (state, payload) => {
		return update(state, {
			companyDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.SET_OWNER]: (state, payload) => {
		return update(state, {
			kioskProductionList: {
				labelToDisplay: {
					$set: payload.labelToDisplay,
				},
			},
		})
	},
}

export default companiesManager
